module.exports = __webpack_public_path__ + "img/32.ac3274a0.jpg";